const benefits = {
  // HeroSection
  'benefits.hero.homeLink': 'Home',
  'benefits.hero.pricingLink': 'Tuition & Benefits',
  'benefits.hero.currentPage': 'Enrollment Benefits',
  'benefits.hero.imgAlt': 'A refined arrangement of butler enrollment gifts and tools',

  // breadcrumb
  'benefits.breadcrumb.home': 'Home',
  'benefits.breadcrumb.pricing': 'Tuition & Benefits',
  'benefits.breadcrumb.current': 'Enrollment Benefits',

  // CourseBenefits
  'benefits.course.label': 'COURSE BENEFITS',
  'benefits.course.title': 'Benefits by Course',
  'benefits.course.titleEn': 'Benefits by Course',
  'benefits.course.lead': 'These are not mementos — they are real, professional-grade tools and equipment for use in butler service from day one. Higher courses add progressively richer provisions, readying you as a professional.',
  'benefits.course.inheritedBadge': 'Included in lower courses',
  'benefits.course.courseLink': ' — View course details',

  // CommonBenefits
  'benefits.common.label': 'COMMON BENEFITS',
  'benefits.common.title': 'Benefits for All Students',
  'benefits.common.titleEn': 'COMMON BENEFITS',
  'benefits.common.certNote': '* The certified qualification is a private credential issued exclusively by the Japan Butler Association. Passing the final practical examination is required for award.',
  'benefits.common.badgeImgAlt': 'A close-up of the certified lapel pin',
  'benefits.common.badgeCaption': 'Certified lapel pin (awarded upon passing the examination)',

  // WhiteGlovesSection
  'benefits.gloves.label': 'WHITE GLOVES',
  'benefits.gloves.title': 'About the White Gloves',
  'benefits.gloves.titleEn': 'WHITE GLOVES',
  'benefits.gloves.imgAlt': 'A butler demonstrating refined movement whilst wearing white gloves',
  'benefits.gloves.pt1Label': 'All courses',
  'benefits.gloves.pt1Desc': 'Provided from day one',
  'benefits.gloves.pt2Label': 'Practicum attire',
  'benefits.gloves.pt2Desc': 'Worn throughout all service practicums',
  'benefits.gloves.pt3Label': 'Symbol',
  'benefits.gloves.pt3Desc': 'Cleanliness, dignity, and professionalism',

  // NotesSection
  'benefits.notes.label': 'NOTES',
  'benefits.notes.title': 'Important Notes',
  'benefits.notes.titleEn': 'Please Note',

  // CTASection
  'benefits.cta.label': 'NEXT STEP',
  'benefits.cta.title': 'View Full Benefit Details in Our Brochure',
  'benefits.cta.lead': 'Request our free brochure for full details on each course\'s enrollment benefits. During an individual consultation, you can also view the actual benefit items in person.',
  'benefits.cta.onlineNote': '* Online consultations are also available.',
  'benefits.cta.certBtn': 'View Certificates & Qualifications',
  'benefits.cta.coursesBtn': 'Browse Courses',
  'benefits.cta.brochureBtn': 'Request a Brochure (Free)',
  'benefits.cta.consultBtn': 'Book a Consultation',

  // FAQSection
  'benefits.faq.label': 'FAQ',
  'benefits.faq.title': 'Frequently Asked Questions',
  'benefits.faq.titleEn': 'Frequently Asked Questions',
  'benefits.faq.contactNote': 'For further enquiries, please use our',
  'benefits.faq.contactLink': 'contact form',
  'benefits.faq.contactSuffix': '.',

  // RelatedPages
  'benefits.related.label': 'LEARN MORE',
  'benefits.related.title': 'Related Pages',
  'benefits.related.titleEn': 'Explore Further',
  'benefits.related.arrowLabel': 'Learn more',

  // footer
  'benefits.footer.lastUpdated': 'Last updated: 13 June 2026',
  'benefits.backToTop.ariaLabel': 'Back to top',

  // benefitsHero
  'benefits.hero.title': 'Enrollment Benefits',
  'benefits.hero.lead': 'Each course comes with a set of benefits designed to be genuinely useful in real butler service from day one.',

  // courseBenefits
  'benefits.courseBenefits.0.name': 'Essential Course',
  'benefits.courseBenefits.0.lead': 'Equipping you with the fundamental tools and kit needed to take your first steps as a butler. From the very first day of study, you will be practising in a professionally-minded environment.',
  'benefits.courseBenefits.0.imageAlt': 'Original practicum apron and butler tool set',
  'benefits.courseBenefits.0.imageCaption': 'Basic tool set and original practicum apron',
  'benefits.courseBenefits.0.item.0.name': 'Basic Tool Set',
  'benefits.courseBenefits.0.item.0.desc': 'A full professional-grade basic butler tool set. For use in real service after graduation.',
  'benefits.courseBenefits.0.item.1.name': 'Textbook Set (Full 5 Volumes — E1–E5)',
  'benefits.courseBenefits.0.item.1.desc': 'Association-supervised 5-volume set covering foundational butlering, from "Introduction to Butlering" to "The English Gentleman\'s Refinement".',
  'benefits.courseBenefits.0.item.2.name': 'Original Practicum Apron',
  'benefits.courseBenefits.0.item.2.desc': 'Academy-made apron for practicum sessions. Premium material that never restricts movement.',
  'benefits.courseBenefits.0.item.3.name': 'White Gloves',
  'benefits.courseBenefits.0.item.3.desc': 'High-quality white gloves. The hallmark of a butler — worn from the very first service practicum.',

  'benefits.courseBenefits.1.name': 'Advanced Course',
  'benefits.courseBenefits.1.lead': 'In addition to the Essential Course benefits, you will receive more specialist tools and teaching materials to deepen your expertise.',
  'benefits.courseBenefits.1.imageAlt': 'Wine opener set',
  'benefits.courseBenefits.1.imageCaption': 'Wine opener set',
  'benefits.courseBenefits.1.item.0.name': 'Basic Tool Set',
  'benefits.courseBenefits.1.item.0.desc': 'A full professional-grade basic butler tool set.',
  'benefits.courseBenefits.1.item.1.name': 'Textbook Set (10 Volumes Total — E1–E5 + A1–A5)',
  'benefits.courseBenefits.1.item.1.desc': 'In addition to the 5 foundational (E) volumes from Essential, 5 applied (A) volumes covering household finance, secretarial support, table service, event planning, and lifestyle management.',
  'benefits.courseBenefits.1.item.2.name': 'Original Practicum Apron',
  'benefits.courseBenefits.1.item.2.desc': 'Academy-made practicum apron.',
  'benefits.courseBenefits.1.item.3.name': 'Wine Opener Set',
  'benefits.courseBenefits.1.item.3.desc': 'Professional wine opener and accessories. Ready for sommelier-level service.',
  'benefits.courseBenefits.1.item.4.name': 'White Gloves',
  'benefits.courseBenefits.1.item.4.desc': 'High-quality white gloves. The hallmark of a butler.',

  'benefits.courseBenefits.2.name': 'Master Course',
  'benefits.courseBenefits.2.lead': 'In addition to Advanced Course benefits, you will receive special equipment befitting a true professional.',
  'benefits.courseBenefits.2.imageAlt': 'Close-up of the custom-made vest and luxury pocket watch',
  'benefits.courseBenefits.2.imageCaption': 'Custom-made vest and luxury pocket watch',
  'benefits.courseBenefits.2.item.0.name': 'Basic Tool Set',
  'benefits.courseBenefits.2.item.0.desc': 'A full professional-grade basic butler tool set.',
  'benefits.courseBenefits.2.item.1.name': 'Complete Textbook Set (All 15 Volumes — E1–E5, A1–A5, M1–M5)',
  'benefits.courseBenefits.2.item.1.desc': 'In addition to the E and A series, 5 master-level (M) volumes covering international protocol, crisis management, and VVIP service — the complete 15-volume set.',
  'benefits.courseBenefits.2.item.2.name': 'Original Practicum Apron',
  'benefits.courseBenefits.2.item.2.desc': 'Academy-made practicum apron.',
  'benefits.courseBenefits.2.item.3.name': 'Wine Opener Set',
  'benefits.courseBenefits.2.item.3.desc': 'Professional wine opener and accessories.',
  'benefits.courseBenefits.2.item.4.name': 'Custom-Made Vest',
  'benefits.courseBenefits.2.item.4.desc': 'Individually fitted and tailored to each student — the academy\'s bespoke practicum vest. Carefully prepared from fitting to delivery.',
  'benefits.courseBenefits.2.item.5.name': 'Luxury Pocket Watch',
  'benefits.courseBenefits.2.item.5.desc': 'A high-quality pocket watch that embodies butler elegance. A piece that enhances the beauty of one\'s movement.',
  'benefits.courseBenefits.2.item.6.name': 'White Gloves',
  'benefits.courseBenefits.2.item.6.desc': 'High-quality white gloves. The hallmark of a butler.',

  // courseBenefits courseLink
  'benefits.course.courseLink.0': 'Essential Course — View course details',
  'benefits.course.courseLink.1': 'Advanced Course — View course details',
  'benefits.course.courseLink.2': 'Master Course — View course details',

  // commonBenefits
  'benefits.common.lead': 'These benefits are provided to every student regardless of course. They give form to the results of your learning and support your path after graduation.',
  'benefits.common.item.0.name': 'Certificate of Completion',
  'benefits.common.item.0.desc': 'A Japan Butler Academy Certificate of Completion is awarded to those who complete the prescribed curriculum.',
  'benefits.common.item.1.name': 'Association Certification & Lapel Pin',
  'benefits.common.item.1.desc': 'Those who pass the final practical examination receive a certification from the All Japan Butler Association (Certified Associate / Professional / Master Butler) and the certified lapel pin. \n\nThis is a private credential issued exclusively by the Association.',
  'benefits.common.item.2.name': 'Graduate Career Support (in preparation)',
  'benefits.common.item.2.desc': 'We are developing a system to share butler-related job opportunities identified by the Association with graduates, to support their career development.',

  // whiteGlovesInfo
  'benefits.gloves.lead': 'White gloves are provided from the very first day across all courses and worn throughout every service practicum. They are the hallmark of the butler\'s movement — embodying cleanliness, dignity, and professionalism. Through practicum, you will acquire the fine motor control needed to handle objects with precision while wearing gloves.',

  // benefitsNotes
  'benefits.notes.0': 'Benefits vary by course. Please check the list above for the specific benefits applicable to your course.',
  'benefits.notes.1': 'We do not assign monetary values to the benefits. Each item has been chosen for its practical utility in real butler service.',
  'benefits.notes.2': 'Benefit contents are subject to change without notice. For the latest information, please consult our brochure or individual consultation.',

  // benefitsFaqs
  'benefits.faq.0.q': 'What benefits will I receive?',
  'benefits.faq.0.a': 'Benefits vary by course and include a butler tool set, textbooks, a practicum apron, and white gloves. Higher courses additionally include a wine opener set (Advanced) and a custom-made vest and luxury pocket watch (Master).',
  'benefits.faq.1.q': 'Are the benefits practical for real-world use?',
  'benefits.faq.1.a': 'Yes. They are not mementos — every item has been chosen for its practical utility in actual butler service.',
  'benefits.faq.2.q': 'Can I also receive the certification?',
  'benefits.faq.2.a': 'Passing the final practical examination at the end of each course earns you an Association certification and certified lapel pin (this is a private credential issued exclusively by the Association).',

  // benefitsRelatedPages
  'benefits.related.0.title': 'Completion Certificate & Certification',
  'benefits.related.0.desc': 'Association certification earned upon completion',
  'benefits.related.1.title': 'Tuition Overview',
  'benefits.related.1.desc': 'Course fees and what is included',
  'benefits.related.2.title': 'Courses Overview',
  'benefits.related.2.desc': 'Compare all three courses at a glance',
  'benefits.related.3.title': 'Detailed Tuition Breakdown',
  'benefits.related.3.desc': 'Full breakdown of each course fee',
};

export default benefits;
